import { FunctionComponent, useEffect, useState } from "react";
import { useCheckout } from "../../context/CheckoutContext";
import styles from "../../pages/Carrinho/Carrinho.module.css";
import ApiService from "../../service/ApiService";

const apiService = new ApiService();

const ProductCard: FunctionComponent = ({
  text,
  title,
  price,
  onSelect,
  selected,
  index,
  img,
  credit_tax,
  debit_tax,
  cred_anual_tax,
  id,
  products_id,
  setBtnDisable,
  normal_price,
  commissionType,
  commissionValue,  
  description,
}: {
  text: string;
  products_id: number;
  id: string;
  img: string;
  title: string;
  onSelect: Function;
  selected: boolean;
  index: number;
  price: number;
  credit_tax: string;
  debit_tax: string;
  cred_anual_tax: string;
  normal_price: price;
  commissionType: string;
  commissionValue: string;  
  setBtnDisable: (value: boolean) => void;
  description?: string;
}) => {
  const [quantity, setQuantity] = useState(0);
  const { cart, addToCart, setTotalPrice } = useCheckout();
  const [taxesLink, setTaxesLink] = useState("");
  const [taxesLinkName, setTaxesLinkName] = useState();

  useEffect(() => {
    apiService.getTaxesLink().then((res) => {
      if (res) {
        setTaxesLink(res.link);
        setTaxesLinkName(res.text);
      }
    });
  }, []);

  useEffect(() => {
    setBtnDisable(!cart.length);
  }, [cart]);

  const handleClick = (value: number) => {
    if (quantity + value !== -1) {
      setQuantity(quantity + value);
      addToCart({
        id,
        name: title,
        price,
        info: "prod",
        quantity: quantity + value,
        img,
        products_id,
        commissionType,
        commissionValue,
        description,
      });
    } else {
    }
  };
  useEffect(() => {
    const prod = cart.find((prod) => prod.id === id);
    if (prod) {
      setQuantity(prod.quantity);
    } else {
      setQuantity(0);
    };
    let somaTotal = 0;
    cart.map((prods) => {
      somaTotal = somaTotal + prods.price * prods.quantity;
    });
    setTotalPrice(parseFloat(somaTotal.toFixed(2)));
  }, [cart, id, quantity]);

  function formatNumber(num: number) {
    let formattedNum = num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Replace commas in the integer part with periods
    let parts = formattedNum.split(".");
    parts[0] = parts[0].replace(/,/g, ".");

    // Join the parts back together
    formattedNum = parts.join(",");

    return formattedNum;
  }

  return (
    <div className={styles.cardCarrinho}>
      <div className={styles.prodTitle}>
        <div className={styles.imagensMaquininhas}>
          <img
            className={styles.image3Icon}
            alt=""
            src={img}
            // src={img ? img : "/image-31@2x.png"}
          />
        </div>
        <div className={styles.textoProduto}>
          <div className={styles.yellyProD1}>{title}</div>
          <span className={styles.descSpan}>{text}</span>
          <div className={styles.s920q92TaxasContainer}>
            {taxesLink !== "" && (
              <>
                <span> + </span>
                <a
                  className={styles.taxasYelly}
                  href={taxesLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className={styles.taxasYelly1}>
                    {taxesLinkName ? taxesLinkName : "Taxas"}*
                  </span>
                </a>
              </>
            )}
          </div>
        </div>
        <div className={styles.textProd}>
          <div className={styles.taxas}>
            <div className={styles.debito}>
              <div className={styles.dbito}>DÉBITO</div>
              <div className={styles.div}>
                {`${formatNumber(parseFloat(debit_tax))}%`}{" "}
              </div>
            </div>
            <div className={styles.credito}>
              <div className={styles.dbito}>CRÉDITO</div>
              <div className={styles.div}>
                {`${formatNumber(parseFloat(credit_tax))}%`}{" "}
              </div>
            </div>
            <div className={styles.credito12x}>
              <div className={styles.dbito}>CRÉD 12X</div>
              <div className={styles.div}>
                {`${formatNumber(parseFloat(cred_anual_tax))}%`}{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.picker}>
        <div className={quantity === 0 ? styles.content : styles.selected}>
          <img
            onClick={() => handleClick(-1)}
            className={styles.icones}
            alt=""
            src="/icones37.svg"
          />
          <div className={styles.div3}>{quantity}</div>
          <img
            onClick={() => handleClick(1)}
            className={styles.icones}
            alt=""
            src="/icones38.svg"
          />
        </div>
      </div>
      {normal_price && normal_price !== '0.00' ? (
        <div className={styles.valor}>
          <div className={styles.vistaPorR} style={{ flexDirection: 'column'}}>
            <span className={styles.grtis}>De R$<s>{ formatNumber(parseFloat(normal_price)) }</s> por</span>
            <div className={styles.vistaPorR}>
            <img className={styles.icones} alt="" src="/creditCard.svg" />
            {`12x de R$ ${formatNumber(price / 12)}`}
            <span className={styles.grtis}> sem juros</span>
            </div>
          </div>
          <div className={styles.emAt12xContainer}>
            <p className={styles.emAt12x}>
              {`Ou por R$ ${formatNumber(parseFloat(price))}`}
              <span style={{ fontWeight: "bolder" }}> à vista</span>{" "}
            </p>
          </div>
        </div>
      ) : (
        <div className={styles.valor}>
          <div className={styles.vistaPorR}>
            <img className={styles.icones} alt="" src="/creditCard.svg" />
            {`12x de R$ ${formatNumber(price / 12)}`}
            <span className={styles.grtis}> sem juros</span>
          </div>
          <div className={styles.emAt12xContainer}>
            <p className={styles.emAt12x}>
              {`Ou por R$ ${formatNumber(parseFloat(price))}`}
              <span style={{ fontWeight: "bolder" }}> à vista</span>{" "}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
